import { ACTION_ITEM_TYPE } from './UserActionItemTabPane'
import { TypographyStyles } from '@/styles'
import { Image, Text } from '@/ui'

export const UserActionItemEmptyState = ({
  tabPaneType,
}: {
  tabPaneType: ACTION_ITEM_TYPE
}) => {
  if (tabPaneType === ACTION_ITEM_TYPE.ACTIVE) {
    return (
      <div className="flex flex-col items-center gap-4 mt-10">
        <Image
          alt="party hat"
          src="https://heard-images.s3.amazonaws.com/assets/party-hat-v2.svg"
          width={180}
          height={180}
          className="mx-auto"
        />

        <div className="flex flex-col items-center gap-2">
          <Text variant={TypographyStyles.H1} textAlign="center">
            Nice work!
          </Text>

          <Text
            variant={TypographyStyles.BODY_MD}
            textAlign="center"
            className="min-h-fit"
          >
            You&apos;re all caught up.
          </Text>
        </div>
      </div>
    )
  }

  return (
    <Text
      variant={TypographyStyles.BODY_LG}
      textAlign="center"
      className="flex flex-col space-y-4 mt-10"
    >
      You don&apos;t have any{' '}
      {tabPaneType === ACTION_ITEM_TYPE.UPCOMING ? 'upcoming' : 'complete'} to
      dos.
    </Text>
  )
}
